import React from 'react';
import { ContentSection, Heading } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';
import { MyDocuments } from '../../components/my-documents';

export const MyDocumentsPage: React.FC = () => {
    const { t } = useTranslation('my-documents');
    const title = t('headline');

    return (
        <ContentSection pageWrapSize="medium">
            <Heading level={1}>{title}</Heading>
            <MyDocuments />
        </ContentSection>
    );
};
